"use client";

import React from "react";
import { Facebook, Instagram, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4, 5].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="flex flex-col gap-3">
        <li data-index={0}>
          <Link to="/diensten" className="text-muted-foreground hover:text-primary transition-colors">Onze Diensten</Link>
        </li>
        <li data-index={1}>
          <Link to="/over-ons" className="text-muted-foreground hover:text-primary transition-colors">Over de Salon</Link>
        </li>
        <li data-index={2}>
          <Link to="/team" className="text-muted-foreground hover:text-primary transition-colors">Ons Team</Link>
        </li>
        <li data-index={3}>
          <Link to="/reviews" className="text-muted-foreground hover:text-primary transition-colors">Klant Ervaringen</Link>
        </li>
        <li data-index={4}>
          <Link to="/contact" className="text-muted-foreground hover:text-primary transition-colors">Contact & Locatie</Link>
        </li>
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const treatments = [{
    name: "Dames Knippen",
    href: "/diensten#knippen"
  }, {
    name: "Kleur & Highlights",
    href: "/diensten#kleuren"
  }, {
    name: "Balayage Specialist",
    href: "/diensten#balayage"
  }, {
    name: "Bruidskapsels",
    href: "/diensten#bruid"
  }];
  const socialLinks = [{
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }, {
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }];
  return <section id="footer" className="dark bg-background text-foreground py-24 px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage#">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/vip_company_logo_footer.png" alt="Logo" className="h-16 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground leading-relaxed">
              Demo website voor uw zaak.
            </p>
            <div className="flex gap-4 mt-2">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} to={social.href} newTab aria-label={social.label} className="bg-secondary text-foreground p-2.5 rounded-full hover:bg-primary hover:text-primary-foreground transition-all duration-300" data-index={i}>
                    <Icon className="size-5" />
                  </Link>;
            })}
            </div>
          </div>

          {}
          <div>
            <h3 className="text-foreground font-bold text-lg mb-6 tracking-wide">Navigatie</h3>
            <MenuProvider menu_id="46">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="text-foreground font-bold text-lg mb-6 tracking-wide">Behandelingen</h3>
            <ul className="flex flex-col gap-3">
              {treatments.map((treatment, i) => <li key={i} data-index={i}>
                  <Link to={treatment.href} className="text-muted-foreground hover:text-primary transition-colors">
                    {treatment.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="text-foreground font-bold text-lg mb-6 tracking-wide">Bedrijfsgegevens</h3>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3 text-muted-foreground">
                <MapPin className="size-5 shrink-0 mt-0.5" />
                <span>Teuge, Nederland</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground">
                <Phone className="size-5 shrink-0" />
                <Link to="tel:0555222413" className="hover:text-primary transition-colors">
                  055 5222413
                </Link>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground">
                <Mail className="size-5 shrink-0" />
                <Link to="mailto:info@vipcompany.nl" className="hover:text-primary transition-colors">
                  info@vipcompany.nl
                </Link>
              </li>
            </ul>
          </div>

        </div>

        <Separator className="mt-20 mb-8 bg-border/50" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} VIP Company. Alle rechten voorbehouden.</p>
          <div className="flex items-center gap-6">
            <Link to="/privacy-policy" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="/algemene-voorwaarden" className="hover:text-primary transition-colors">
              Algemene Voorwaarden
            </Link>
          </div>
        </div>
      </div>
    </section>;
}